import useSWR from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';
import { withQueryParams } from '@shared/commonFunctions';

export const useRefreshComments = (dealId?: string | boolean, contactId?: string, includeUrlParams = true) => {
  let apiPath = '';
  if (!dealId) {
    apiPath = withQueryParams(`/${SERVICES.CONTACT}/contact-comments`, {
      contactId,
      pageNumber: 1,
      pageSize: 1000,
    }, includeUrlParams);
  } else {
    apiPath = withQueryParams(`/${SERVICES.DEAL}/deals/${dealId}/comments`, {
      pageNumber: 1,
      pageSize: 1000,
    }, includeUrlParams);
  }

  const { mutate: refreshComments } = useSWR(apiPath, { revalidateOnMount: false });

  return refreshComments;
};


